export default __webpack_public_path__ + "static/media/16.ffb74978.jpg";